import React, { useState } from 'react'
import Box from '@mui/material/Box'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import ClaimRangeForm from './ClaimRangeForm'

const PolicyFormModal = ({ children, policyData, approvalRoutes, reimbursementAdmins }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }

  return (
    <>
      <Box onClick={handleOpen}>{children}</Box>
      <AdxFormModal
        open={isModalOpen}
        handleClose={handleClose}
        disableAutoFocus
        onClose={(_, reason) => {
          if (reason !== 'backdropClick') {
            handleClose()
          }
        }}
        title={'Claim Approval Rules'}
        childPadding={false}
        sxModal={{ minWidth: { xs: 1, md: 900 } }}
      >
        <ClaimRangeForm
          handleClose={handleClose}
          policyData={policyData}
          approvalRoutes={approvalRoutes}
          reimbursementAdmins={reimbursementAdmins}
        />
      </AdxFormModal>
    </>
  )
}

export default PolicyFormModal
